import React, {useEffect, useState} from "react";
import {
    useNavigate,
  } from "react-router-dom";

import "./sign_up.css"
import { useTranslation } from 'react-i18next';

const config = require('../config');
const host = config.host;
const port = config.port;


export const SignUp = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [pin, setPin] = useState('');
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const { t } = useTranslation();
  

    const handleSignUp = () => {
      // Here, you would send the phone number and pin to your backend for verification
      if(!phoneNumber || !pin || ! password){
        alert('Please enter your phone number, PIN and password.');
        return;
      }
  

      fetch(`/auth/register`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          {phone_no:`${phoneNumber}`,
          country_code: `${countryCode}`,
          password: password,
          keyword: "",
          favourite_image: "",
          quota: 5,
          secretCode: "this is a user",
          user_input_PIN: pin // pass to backend for verification
          })
      })
      .then(response => {
        if(response.ok){
          navigate("/login");
          alert("User registered successfully");
        }
        else{
          return response.json();
        }
      })
      .then(data => {
        alert(data.message);
      })
      .catch(error => {
          console.error('Error:', error);
      });
      
    }
  
    const handlePIN = async () => {
      if(!phoneNumber || !countryCode){
        alert('Please enter your phone number and country code.');
        return;
      }

      function containsOnlyDigits(input) {
        const regex = /^\d+$/;
        return regex.test(input);
      }
      if (!containsOnlyDigits(`${countryCode}${phoneNumber}`)){
        alert('Please enter a valid phone number');
        return;
      }

      fetch(`/api/send_PIN`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          {
            phone_no:`${phoneNumber}`,
            country_code:`${countryCode}`
          })
        }
      )
      .then(response => response.json())
      .then(data => alert(data.message))
      .catch(error => console.log(error));
    }


  const [isCooldown, setIsCooldown] = useState(false);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    let timer;
    if (isCooldown && countdown > 0) {
      timer = setInterval(() => {
        setCountdown(prevCountdown => prevCountdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      setIsCooldown(false);
    }
    return () => clearInterval(timer);
  }, [isCooldown, countdown]);

  const TurnOffForAwhile = () => {
    setIsCooldown(true);
    setCountdown(30);
  };

    return (
      <>
      
      <div className="first-page-box first-page-top-box">
              <span className="main-title">Ring<br/>Generation</span>
      </div>

      <div className="sign_up-container">
      <div className="sign_up-box">
      <div className="title-box">
        <h2 className="sign_up-title">{t("sign_up")}</h2>
        <div className="line"></div>
		  </div>
      
        <label htmlFor="phone number">{t("phone_number")}</label>
        <div className="input-group">
          <input
            id="CCC"
            type="text"
            placeholder={t("country_code")}
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            className="input-field"
          />
          <input
            type="text"
            placeholder={t("phone_no_placeholder")}
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className="input-field"
          />
        </div>
        <button id="PIN_button" onClick={() => {TurnOffForAwhile();handlePIN();}} disabled={isCooldown} className="sign-up-action-button">
          {isCooldown ? `${countdown}s` : t("receive_PIN")}
        </button>
        <label htmlFor="PIN">{t("PIN")}</label>
        <div className="input-group">
          <input
            type="text"
            placeholder={t("PIN_placeholder")}
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            className="input-field"
          />
        </div>
        <label htmlFor="password" style={{ display: 'block', marginBottom: '3px' }} >{t("password")}</label>
        <input
            type="password"
            placeholder={t("password_placeholder")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-field"
          />
        
        <button onClick={() => handleSignUp()} className="sign-up-action-button">
          {t("sign_up_account")}
        </button>
      </div>
    </div>


    </>
      );
  }
